// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u7Yb+","sytem_name":"Footer_sytem_name__30kkz","space":"Footer_space__qaLDQ"};